import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IOnLazyLoad } from '@hub/interfaces/IOnLazyLoad';
import { SubGridItem } from '@hub/models/common/ui/SubGridItem';
import { SortMeta } from 'primeng/api';
import { Subject } from 'rxjs';
import { eColumnType } from '@hub/generated/enums';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-sub-grid',
  templateUrl: './subGrid.component.html'
})
export class SubGridComponent implements OnInit, OnDestroy {
  constructor() { }

  // Inputs
  @Input() Title: string = null;
  @Input() Data: Subject<any[]>;
  @Input() Columns: SubGridItem[];
  @Input() EnableSelection: boolean = false;
  @Input() RowsPerPageOptions: number[];
  @Input() TotalCount: number;
  @Input() Page: number;
  @Input() PageSize: number;
  
  @Input() set Sorting(sm: SortMeta[]) {
    if (Array.isArray(sm) && sm.length > 0) {
        this.sortField = sm[0].field;
        this.sortOrder = sm[0].order;
    }
  }
  @Input() Selection: any[] = [];
  @Input() ShowPaginator = true;

  // Outputs
  @Output() LazyLoadEvent: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();
  @Output() ColumnsChange: EventEmitter<SubGridItem[]> = new EventEmitter<SubGridItem[]>();
  @Output() SelectionChange: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() onReorder: EventEmitter<IOnLazyLoad> = new EventEmitter<IOnLazyLoad>();
  @Output() faIconClick = new EventEmitter();
  
  // Enumerations
  public type = eColumnType;

  // Public Fields
  public isEdit: boolean = false;
  public data: any[];
  sortField: string;
  sortOrder: number;

  // Properties
  public get footerText(): string {
    if (this.TotalCount > 0) {
      const start = (this.Page - 1) * this.PageSize + 1;
      let end = start + this.PageSize - 1;

      if (end > this.TotalCount) {
        end = this.TotalCount;
      }

      return `${start} - ${end} of ${this.TotalCount} items`;
    }

    return '';
  }

  // Private Fields
  private unsubscriber: Subject<void> = new Subject<void>();

  // Public Methods
  public reorder(values) {
    const reorderColumns: SubGridItem[] = new Array<SubGridItem>();
    let index = 1;
    for (const val of values.columns) {
      const column = this.Columns.find(
        f => f.Header === (val.Header === undefined ? '' : val.Header)
      );
      column.Order = index;
      reorderColumns.push(column);
      index++;
    }

    this.Columns = reorderColumns;

    this.ColumnsChange.emit(this.Columns);
  }

  // Lazy Load
  public onLazyLoad(event) {
    this.LazyLoadEvent.emit(event);
  }

  // Selection
  public rowSelect(event) {
    this.SelectionChange.emit(this.Selection);
  }

  public rowUnselect(event) {
    this.SelectionChange.emit(this.Selection);
  }

  public toggleSelection() {
    this.SelectionChange.emit(this.Selection);
  }

  onPage(event) {
    this.Selection = [];
    this.SelectionChange.emit(this.Selection);
  }

  public iconClickHandler(event){
    this.faIconClick.emit(event);
  }
  // Sorting

  // OnInit
  public ngOnInit(): void {
    this.Data
      .pipe(takeUntil(this.unsubscriber))
      .subscribe(data => {
        this.data = data;
      });
    
    setTimeout(() => this.onLazyLoad({sortField: this.sortField, sortOrder: this.sortOrder}));
  }

  // OnDestroy
  public ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
